/* eslint-disable */
import React, { Component } from 'react';

export default class MonthView extends Component {
    componentDidMount() {
        console.log(this.props);
    }

    render() {
        const { event } = this.props;
        const [amount, status] = event.title.split(' ');
        return (
            <div>
                <div
                    style={{
                        zIndex: 0,
                    }}
                    className={`margin-left rt-status-cell bullet bullet-left bullet-status-${event.status}`}
                >
                    {amount > 1 ? `x${amount}` : null} {status}
                </div>
            </div>
        );
    }
}
